import type { App } from "vue";
import { en, nl } from "@formkit/i18n";
import { defaultConfig, type DefaultConfigOptions, plugin, createInput } from "@formkit/vue";
import { primeInputs } from "@sfxcode/formkit-primevue";
import FormKitSelectEntity from "src/components/form/FormKitSelectEntity.vue";
import FormKitJsonEditor from "src/components/form/FormKitJsonEditor.vue";

export const installFormKitPlugin = (app: App) => {
  const config: DefaultConfigOptions = {
    locales: { nl, en },
    locale: "nl",
    inputs: {
      ...primeInputs,

      selectEntity: createInput(FormKitSelectEntity, {
        props: [
          "entity",
          "entityLabel",
          "entityValue",
          "labelSeparator",
          "placeholder",
          "label",
          "requests",
          "sourceField",
        ],
      }),

      jsonEditor: createInput(FormKitJsonEditor),
    },
  };

  app.use(plugin, defaultConfig(config));
};
